import { Component } from '@angular/core';
import { gapFormUrl } from '../../../shared/form-url';

@Component({
  selector: 'app-when-to-buy',
  templateUrl: './when-to-buy.component.html',
  styleUrls: ['./when-to-buy.component.scss'],
})
export class WhenToBuyComponent {
  readonly formUrl = gapFormUrl;
}
